import React, { useState, useEffect } from "react";
import ConfirmDialog from "../../../components/actionDialogs/confirmDialog";
import CustomTable from "../../../components/table/table";
import "./view.css";
import { admin_market_analysis_delete, get_market_analysis_list } from "../admin.api";
import Loader from "../../../components/loader/loader";
import Snackbar from "../../../components/snackbar/snackbar";
import jwtDecode from "jwt-decode";
import AddMarketAnalysis from "./add";
import EditMarketAnalysis from "./edit";
import ViewMarketAnalysis from "./view";

export default function View(props) {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [isActive, setIsActive] = useState(true);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [openAction, setOpenAction] = useState(false);
  const [activeData, setActiveData] = useState({});
  const [addNew, setAddNew] = useState(false);
  const [edit, setEdit] = useState(false);
  const [editData, setEditData] = useState({});
  const [view, setView] = useState(false);
  const [viewData, setViewData] = useState({});
  const [showFilters, setShowFilters] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");

  let adminType = Number(jwtDecode(props.state.payload).user_type);

  const handleMarketAnalysisList = async () => {
    setIsActive(true);
    try {
      const res = await get_market_analysis_list();
      const tdata = Array.isArray(res)
        ? res.map((item, index) => ({
          ...item,
          slno: index + 1,
        }))
        : [];

      setData(tdata);
    } catch (error) {
      setData([]);
      setSnackMessage(error?.response?.data?.message || error?.message || "Failed to fetch market analysis list");
      setIsSnackError(true);
      setSnackOpen(true);
    } finally {
      setIsActive(false);
    }
  };

  const applyFilters = () => {
    let filtered = [...data];
    if (searchTerm) {
      filtered = filtered.filter(item =>
        item.opportunity && item.opportunity.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }
    setFilteredData(filtered);
  };

  useEffect(() => {
    handleMarketAnalysisList();
  }, []);

  useEffect(() => {
    setFilteredData(data);
  }, [data]);

  useEffect(() => {
    applyFilters();
  }, [searchTerm, data]);

  useEffect(() => {
    return () => {
      setData([]);
      setFilteredData([]);
    };
  }, []);

  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      handleMarketAnalysisList();
    }
  };

  const handleAddNew = () => {
    setAddNew(true);
  };

  const handleClose = (msg, isError = false) => {
    setAddNew(false);
    setEdit(false);
    setEditData({});
    setView(false);
    setViewData({});
    handleMarketAnalysisList();
    if (msg) {
      setSnackMessage(msg);
      setIsSnackError(isError);
      setSnackOpen(true);
    }
  };

  const handleView = (row) => {
    setViewData(row);
    setView(true);
  };

  const handleEdit = (row) => {
    setEditData(row);
    setEdit(true);
  };

  const handleDelete = (row) => {
    setActiveData(row);
    setOpenAction(true);
  };

  const handleCancelDelete = () => {
    setOpenAction(false);
  };

  const handleDeleteConfirm = (row) => {
    setOpenAction(false);
    setIsActive(true);
    admin_market_analysis_delete(row.id)
      .then((res) => {
        setSnackMessage(res.message);
        setIsSnackError(false);
        setSnackOpen(true);
        setIsActive(false);
      })
      .catch((error) => {
        setSnackMessage(error?.response?.data?.message || error?.message || "Delete failed");
        setIsSnackError(true);
        setSnackOpen(true);
        setIsActive(false);
      });
  };

  return (
    <div className="container-fluid mt-4">
      <Loader open={isActive} />
      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />
      <div className="card shadow-sm">
        <div className="card-header bg-white py-3 d-flex justify-content-between align-items-center">
          <h5 className="mb-0">
            <b>Market Analysis</b>
          </h5>
          <div className="d-flex gap-2">
            {adminType === 1 && (
              <button
                className="btn btn-primary btn-sm search-style border-0 text-white rounded"
                onClick={handleAddNew}
              >
                Add New
              </button>
            )}
            <button
              className={`filter-icon-btn ${showFilters ? "active" : ""}`}
              onClick={() => setShowFilters(!showFilters)}
              title="Toggle Filters"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
              </svg>
            </button>
          </div>
        </div>

        <div className="card-body pt-0">
          <div className={`filter-container ${showFilters ? "show" : ""}`}>
            <div className="row align-items-end mb-3">
              <div className="col-md-4">
                <label className="form-label small">Opportunity</label>
                <input
                  type="text"
                  className="form-control filter-select"
                  placeholder="Search opportunity..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
              <div className="col-md-3 d-flex gap-2">
                <button
                  className="filter-action-btn"
                  title="Reset Filters"
                  onClick={() => {
                    setSearchTerm("");
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"></path>
                    <path d="M3 3v5h5"></path>
                  </svg>
                </button>
                <button
                  className="filter-action-btn close-btn"
                  title="Close Filters"
                  onClick={() => setShowFilters(false)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                </button>
              </div>
            </div>
          </div>
          <CustomTable
            {...props}
            columns={[
              { title: "Sl No", field: "slno", style: { width: "70px", maxWidth: "70px" } },
              { title: "Opportunity", field: "opportunity" },
            ]}
            data={filteredData}
            actions={
              adminType === 1
                ? [
                  { type: "view", handleClick: handleView },
                  { type: "edit", handleClick: handleEdit },
                ]
                : [
                  { type: "view", handleClick: handleView },
                  { type: "delete", handleClick: handleDelete }
                ]
            }
          />
        </div>
      </div>
      {openAction && (
        <ConfirmDialog
          open={openAction}
          title="Delete Market Analysis ?"
          data={activeData}
          message="Are you sure to delete this Market Analysis?"
          secondary_action="Cancel"
          primary_action="Delete"
          handleClose={handleCancelDelete}
          handleConfirm={handleDeleteConfirm}
        />
      )}
      {addNew && (
        <AddMarketAnalysis
          open={addNew}
          handleClose={handleClose}
          {...props}
        />
      )}
      {edit && (
        <EditMarketAnalysis
          open={edit}
          handleClose={handleClose}
          editData={editData}
          {...props}
        />
      )}
      {view && (
        <ViewMarketAnalysis
          open={view}
          handleClose={handleClose}
          viewData={viewData}
          {...props}
        />
      )}
    </div>
  );
}
